import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CONSENT_KEY = 'cookie_consent';

export function hasConsent() {
  return localStorage.getItem(CONSENT_KEY) === 'accepted';
}

export default function CookieConsent({ onAccept }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
    if (onAccept) onAccept();
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
  };

  return (
    <div style={styles.banner}>
      <p style={styles.text}>
        We use cookies to analyse traffic and improve your experience. By accepting, you consent to our use of analytics cookies.{' '}
        <Link to="/support/cookies" style={styles.link}>Cookie Policy</Link>
      </p>
      <div style={styles.buttons}>
        <button onClick={accept} style={styles.accept}>Accept All</button>
        <button onClick={decline} style={styles.decline}>Reject All</button>
      </div>
    </div>
  );
}

const styles = {
  banner: { position: 'fixed', bottom: 0, left: 0, right: 0, background: '#1a1a2e', color: '#fff', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', zIndex: 99999, flexWrap: 'wrap', gap: '12px', boxShadow: '0 -2px 10px rgba(0,0,0,0.3)' },
  text: { margin: 0, fontSize: '14px', flex: 1, minWidth: '200px' },
  buttons: { display: 'flex', gap: '10px' },
  accept: { background: '#4CAF50', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' },
  decline: { background: 'transparent', color: '#ccc', border: '1px solid #ccc', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer' },
  link: { color: '#90caf9', textDecoration: 'underline' },
};
